
import axios from 'axios'

const getStatesByCountry =  async(countryId) => {
    const response = await axios.get(`/country/${countryId}/state`)
    return response.data
}

export default getStatesByCountry;